import styled, { css } from 'styled-components'
import Icon from '@/ui/Icon'
import {
  ActionsOverflowProps,
  DocumentActionsProps,
  ScrollContainerProps,
} from './types'

export const PDFViewerContainer = styled.div`
  position: relative;
  background: ${props => props.theme.colors.backgroundColor};

  .react-pdf__Page:not(:last-child) {
    margin-bottom: 30px;
  }
`

export const ScrollContainer = styled.div<ScrollContainerProps>`
  overflow: ${({ disabled }) => (disabled ? 'visible' : 'scroll')};

  .document-container {
    width: 100%;
  }
  .file-outer-container {
    min-height: 90vh;
  }
  .file-outer-container .pg-viewer-wrapper {
    overflow: visible;
  }
`

export const FullscreenButtonContainer = styled.div`
  position: absolute;
  right: 1em;
  bottom: 1em;
  z-index: 1;
`

export const FullscreenButton = styled(Icon).attrs({
  button: true,
  bordered: true,
  circular: true,
  size: 'big',
})`
  &&& {
    color: gray;
    background: #fff;
  }
`

export const ActionsOverflow = styled.div<ActionsOverflowProps>`
  ${({ sticky }) => css`
    overflow: ${sticky ? 'unset' : 'hidden'};
    position: ${sticky ? 'sticky' : 'absolute'};
    top: ${sticky ? '-40px' : 0};
    z-index: 5;
    width: 100%;
  `}
`
export const DocumentActions = styled.div<DocumentActionsProps>`
  background-color: ${props => props.theme.colors.abyss}b3;
  transition: opacity 0.2s ease;
  width: 100%;
  padding: 22px 15px;
  top: 0;
  display: flex;
  color: #fff;
  justify-content: space-between;
  align-items: center;
  opacity: ${({ hide }) => (hide ? 0 : 1)};

  button {
    background-color: rgba(0, 0, 0, 0);
    border: 0;
    outline: 0;
    color: #fff;
    display: flex;
    align-items: center;
    transform: translateX(-30px);
    cursor: pointer;
    i {
      color: #fff !important;
      margin-left: 5px;
      cursor: pointer !important;
    }
  }

  ${({ theme }) => theme.mediaQueries.mobile} {
    padding: 10px;

    button {
      transform: none;
      position: absolute;
      top: 10px;
      right: 45px;

      span {
        display: none;
      }
    }
  }
`

export const PageNumberWrapper = styled.div`
  position: relative;
  top: 1px;
`

export const PageNumber = styled.input.attrs({
  type: 'number',
})`
  &&&&&& {
    position: relative;
    top: -1px;
    width: 35px !important;
    padding: 0 5px !important;
    margin: 0 5px !important;
    border: 0 !important;
    color: #fff !important;
    background-color: ${props => props.theme.colors.abyss}80 !important;
    -moz-appearance: textfield; /* Firefox */
  }

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

export const Overlay = styled.div`
  background-color: #cdcdcd;
  min-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const DocumentLoader = styled.div`
  width: 140px;
  min-height: 195px;
  position: relative;
  padding: 5px;
  border-radius: 4px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;

  :before {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-bottom-left-radius: 2px;
    border-width: 5px;
    border-style: solid;
    border-color: #cdcdcd #cdcdcd rgba(0, 0, 0, 0.35) rgba(0, 0, 0, 0.35);
    border-bottom-left-radius: 4px;
    border-width: 16px;
  }
`

export const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 4px solid rgba(255, 255, 255, 0);
  border-top: 4px solid ${props => props.theme.primaryColor};
  border-radius: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  animation: rotate 1s infinite linear;

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`
